<template>
  <div class="app-layout">
    <app-sidebar :collapsed="isSidebarCollapsed" />
    <app-navbar @toggle-sidebar="handleSidebarToggle" />
    <main class="main-content" :class="{ 'sidebar-collapsed': isSidebarCollapsed }">
      <page-default />
    </main>
    <app-footer />
  </div>
</template>

<script>
import AppSidebar from './sideBar.vue'
import AppNavbar from './navBar.vue'
import PageDefault from './pageDefault.vue'
import AppFooter from './footer.vue'

export default {
  name: 'LayoutPrincipal',
  components: {
    'app-sidebar': AppSidebar,
    'app-navbar': AppNavbar,
    'page-default': PageDefault,
    'app-footer': AppFooter
  },
  data() {
    return {
      isSidebarCollapsed: false
    }
  },
  methods: {
    handleSidebarToggle(collapsed) {
      this.isSidebarCollapsed = collapsed;
    }
  }
}
</script>

<style scoped>
.app-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-content {
  margin-left: 280px;
  margin-top: 70px;
  flex: 1;
  background: #f8fafc;
  min-height: calc(100vh - 70px);
  transition: margin-left 0.3s ease;
}

.main-content.sidebar-collapsed {
  margin-left: 70px;
}
</style>